import { Fragment } from "react";

const items = [
  "Systematic Reviews",
  "Meta-Analysis",
  "Real-World Evidence",
  "Grant Proposals",
  "Clinical Protocols",
  "SAR / MoA Analysis",
  "Graphical Abstracts",
  "Journal Selection",
  "Thesis Editing",
  "Regulatory Writing",
  "Case Reports",
  "Publication Strategy",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-slate-200 bg-white py-5"
  >
    <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap hover:[animation-play-state:paused]">
      {[...items, ...items].map((item, i) => (
        <Fragment key={i}>
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500 sm:text-sm">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rounded-full bg-coral-400" aria-hidden="true" />
        </Fragment>
      ))}
    </div>
  </div>
);
